import { ContactField } from '../ContactField/ContactField';
import type { ContactFieldConfig } from '../ContactField/ContactField';

const FIELDS: ContactFieldConfig[] = [
  { name: 'firstName', label: 'First name', isRequired: true },
  { name: 'lastName', label: 'Last name', isRequired: true },
  { name: 'position', label: 'Position', isRequired: true },
  { name: 'email', label: 'Email', type: 'email', isRequired: true },
  { name: 'phone', label: 'Direct phone', type: 'tel', isRequired: true },
];

const PARENT = 'principalContact';

export const PrincipalContact = ({ isEditMode }: { isEditMode: boolean }) => (
  <>
    {FIELDS.map((field) => (
      <ContactField
        key={field.name}
        {...field}
        parent={PARENT}
        isEditMode={isEditMode}
      />
    ))}
  </>
);
